<!--The content below is only a placeholder and can be replaced.-->
<app-loading-overlay></app-loading-overlay>
<app-header></app-header>
<!-- <app-list-horizont></app-list-horizont> -->
<div class="router" [ngClass]="{'enabled':start}" [@routeAnimations]="o && o.activatedRouteData
      && o.activatedRouteData['animation']">
  <router-outlet #o="outlet"></router-outlet>
</div>
<!-- <audio id="audio" src="http://stream.piperrak.cc/brba.mp3" autoplay></audio> -->
